<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14AsYVQ/tc-custom/9780740786150.jpg?1707452598761" alt="This image is the cover for the book Scourge of Vinyl Car Seats, Close to Home"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scourge of Vinyl Car Seats, Close to Home
      </h1>
      <p class="bookDescription body article font2">
        <p>No one walks away from a <i>Close to Home</i> cartoon unscathed. John McPherson's lumpy characters and bizarre situations are tailor-made for gut-splitting laughs. And then there are the cartoons that leave readers shaking their heads, sputtering, "Oh my gosh" as a guilty smile passes across their faces. <i>The Scourge of Vinyl Car Seats</i> delivers what fans expect from McPherson: jokes about everything from parenting to dating to car repairs. McPherson takes his readers on a journey that's very Close to Home.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John McPherson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ce233c58